import React from 'react'

import {globals} from '@extensions/globals-base'
import Editor, {EditorProps} from '@monaco-editor/react'
import {Lang} from 'yougile-lang'

type Props = Pick<EditorProps, 'value' | 'onChange'>

export const YamlEditor = (props: Props) => {
  return (
    <Editor
      height="100%"
      language="yaml"
      loading={Lang.msg.common.loading}
      theme={globals.theme === 'dark' ? 'vs-dark' : 'vs'}
      options={{
        minimap: {enabled: false},
        fontSize: 16
      }}
      {...props}
    />
  )
}
